/* eslint-disable no-return-assign */
import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import { ModalContext } from 'App';
// import { Acl } from 'modules/common/components/Acl';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { get } from 'session';
import useFormValidator from 'useFormValidator';
import PropTypes from 'prop-types';
import Select from 'react-select';
// import ViewSOA from './ViewSOA';
import ViewUpdateBusinessOperations from './ViewUpdateBusinessOperations';
import ViewUpdateBusinessActivityItem from './ViewUpdateBusinessActivityItem';
import ViewUpdateFeeCalculationItem from './ViewUpdateFeeCalculationItem';
import * as actions from '../actions';
import * as c from '../constant';

const commonValidation = {
  base_line: 'required|number',
  area: 'required|number',
  floor_area: 'required|number',
  no_of_employees_residing_manila: 'required|number',
  no_of_male_employees: 'required|number',
  no_of_female_employees: 'required|number',
  no_of_van: 'required|number',
  no_of_truck: 'required|number',
  no_of_motorcycle: 'required|number',
};

function ViewUpdateCalculation({
  data,
  updateDelinquentCalculation,
  getVetRegistrationList,
  vetRegistrationList,
  updating,
  getBusinessNecessaryField,
  businessNecessaryField,
  handleGenerateSOA,
  getCalculationDetailsByBarangay,
}) {
  const [formData, setFormData] = React.useState({});
  const setModal = useContext(ModalContext);
  const businessActivityList = _.get(data, 'included.bplsBusinessActivities');
  const businessDetails = _.get(
    data,
    'included.bplsBusiness.attributes.details'
  );
  const business = _.get(data, 'included.bplsBusiness.attributes');
  const applicationStatusId = get('applicationStatusId') || 0;
  const mainOfficeBarangayCode = _.get(
    data,
    'included.bplsBusiness.attributes.main_office_barangay_code'
  );
  const dataId = _.get(data, 'id');
  const formCalculationDetails = _.get(formData, 'calculation_details', []);
  const businessDetailsQuantityMatrix = _.get(
    data,
    'included.bplsBusiness.attributes.details.quantity_matrix'
  ); 

  useEffect(() => {
    if (!applicationStatusId) return;
    getBusinessNecessaryField({ application_status_id: +applicationStatusId });
  }, [applicationStatusId]);

  const checkNumberOfEmployees = (employeesData) => {
    if (
      _.get(business, 'no_of_employees') === 0 ||
      _.get(business, 'no_of_employees') === '0'
    )
      return '0';
    if (
      _.get(business, 'no_of_employees') !== 0 ||
      _.get(business, 'no_of_employees') !== '0'
    ) {
      if (
        (employeesData === 0 || employeesData === '0') &&
        (_.get(business, 'no_of_male_employees') !== 0 ||
          _.get(business, 'no_of_female_employees') !== 0)
      )
        return '0';
      if (
        (employeesData === 0 || employeesData === '0') &&
        (_.get(business, 'no_of_male_employees') === 0 ||
          _.get(business, 'no_of_female_employees') === 0)
      )
        return '';
    }
    return employeesData;
  };

  useEffect(() => {
    getVetRegistrationList();
  }, []);

  useEffect(() => {
    if (!mainOfficeBarangayCode || !dataId) return;
    getCalculationDetailsByBarangay(
      dataId,
      {
        main_office_barangay_code: mainOfficeBarangayCode,
      },
      (res) => {
        const multiplierQuantityMatrix = Object.values(businessDetailsQuantityMatrix ?? {})
          .flatMap(item => _.isArray(item) ? item : [])
          .reduce((acc, { multiplier, value }) => {
            if (multiplier && !_.isNaN(value)) {
              acc[multiplier] = +value;
            }
            return acc;
          }, {});

        const combinedDetails = {
          ...businessDetails,
          quantity_matrix: multiplierQuantityMatrix
        }
          
        setFormData({
          ...formData,
          activities: Object.keys(businessActivityList).map((activity) => ({
            activity_id: _.get(businessActivityList, `${activity}.id`) || '',
            yearly_gross_amount:
              _.get(
                businessActivityList,
                `${activity}.attributes.yearly_gross_amount`
              ) || '',
            yearly_details:
              _.get(
                businessActivityList,
                `${activity}.attributes.yearly_details`
              ) || '',
          })),
          base_line: _.get(business, 'base_line', 0),
          veterinary_fee_id: _.get(
            data,
            'included.bplsBusiness.attributes.veterinary_fee_id',
            ''
          ),
          calculation_details: _.get(res, 'res', []),
          details: combinedDetails,
          area: _.get(business, 'area', ''),
          floor_area: _.get(business, 'floor_area', ''),
          no_of_employees: _.get(business, 'no_of_employees', 0),
          no_of_employees_residing_manila: checkNumberOfEmployees(
            _.get(business, 'no_of_employees_residing_manila', 0)
          ),
          no_of_male_employees:
            _.get(business, 'no_of_employees') === 0
              ? '0'
              : `${_.get(business, 'no_of_male_employees', 0)}`,

          no_of_female_employees:
            _.get(business, 'no_of_employees') === 0
              ? '0'
              : `${_.get(business, 'no_of_female_employees', 0)}`,
          no_of_vehicles: _.get(business, 'no_of_vehicles', 0),
          no_of_van: _.get(business, 'no_of_van', 0),
          no_of_truck: _.get(business, 'no_of_truck', 0),
          no_of_motorcycle: _.get(business, 'no_of_motorcycle', 0),
        });
      }
    );
  }, [mainOfficeBarangayCode, dataId]);

  const handleSubmit = (e) => {
    e.preventDefault();

    const args = {
      ...formData,
      base_line: _.get(formData, 'base_line') || '',
      veterinary_fee_id: _.get(formData, 'veterinary_fee_id') || '',
    };

    updateDelinquentCalculation(_.get(data, 'id'), args, () => {
      handleGenerateSOA();
    });
  };

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleOnChangeSelect = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
  };

  const vetRegistrationListOption =
    vetRegistrationList.map((vetRegItem) => ({
      label: _.get(vetRegItem, 'attributes.veterinary_registration'),
      value: _.get(vetRegItem, 'id'),
    })) || '';
  vetRegistrationListOption.unshift({ label: 'Select', value: '' });

  const validateForm = useFormValidator(formData, commonValidation);

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  const onChangeDetails = (type, key, value) => {
    if (type === 'multiplier') {
      setFormData((prev) => ({
        ...prev,
        details: {
          ...prev.details,
          [key]: value,
        },
      }));
    }

    if (type === 'quantity_matrix') {
      setFormData((prev) => ({
        ...prev,
        details: {
          ...prev.details,
          quantity_matrix: {
            ...prev.details.quantity_matrix,
            [key]: value,
          }
        },
      }));
    }
  };

  return (
    <Modal.Body>
      <form>
        <div>
          <Tabs>
            <TabList>
              <Tab>Business Operation Details</Tab>
              <Tab>Calculation Details</Tab>
              <Tab>Business Activity Details</Tab>
            </TabList>
            <TabPanel>
              <ViewUpdateBusinessOperations
                formData={formData}
                setFormData={setFormData}
                onChange={onChange}
                validateForm={validateForm}
                businessNecessaryField={businessNecessaryField}
                onChangeDetails={onChangeDetails}
              />
            </TabPanel>
            <TabPanel>
              <div className="p-3">
                <div className="row">
                  <div className="col-6 form-group">
                    <label htmlFor="last_name" className="form-label mb-0">
                      Base Line {validateForm.renderMessage('base_line')}
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="base_line"
                      onChange={onChange}
                      value={_.get(formData, 'base_line') || ''}
                    />
                  </div>
                  <div className="col-6 form-group">
                    <label htmlFor="last_name" className="form-label mb-0">
                      Veterinary Registration
                    </label>
                    <Select
                      placeholder="Select"
                      onChange={handleOnChangeSelect('veterinary_fee_id')}
                      options={vetRegistrationListOption}
                      value={
                        vetRegistrationListOption.find((vetRegOption) => {
                          return (
                            `${_.get(formData, 'veterinary_fee_id')}` ===
                            _.get(vetRegOption, 'value')
                          );
                        }) || ''
                      }
                    />
                  </div>
                </div>
                <hr />
                <div className="row p-2">
                  <div className="col-2">
                    <div className="form-group mb-0">
                      <label className="form-label mb-0">Code</label>
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="form-group mb-0">
                      <label className="form-label mb-0">Description</label>
                    </div>
                  </div>
                  <div className="col-1">
                    <div className="form-group mb-0">
                      <label className="form-label mb-0">Year</label>
                    </div>
                  </div>
                  <div className="col-2">
                    <div className="form-group mb-0">
                      <label className="form-label mb-0">Period</label>
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="form-group mb-0">
                      <label className="form-label mb-0">Amount</label>
                    </div>
                  </div>
                </div>
                <div
                  className=""
                  style={{ maxHeight: '60vh', overflow: 'hidden scroll' }}
                >
                  {formCalculationDetails
                    ? formCalculationDetails.map(
                        (calculationItem, calculationId) => {
                          const previousItem =
                            calculationId > 0
                              ? formCalculationDetails[calculationId - 1]
                              : null;
                          const isNewYear = previousItem
                            ? previousItem.year !== calculationItem.year
                            : true;

                          return (
                            /* eslint-disable */
                            <React.Fragment
                              key={`calculation-${calculationId}`}
                            >
                              {isNewYear && calculationId > 0 && (
                                <div className="w-100">
                                  <hr className="my-3" />
                                </div>
                              )}
                              <div className="row">
                                <ViewUpdateFeeCalculationItem
                                  id={calculationId}
                                  data={calculationItem}
                                  feeCalculationFormData={formData}
                                  setFeeCalculationFormData={setFormData}
                                />
                              </div>
                            </React.Fragment>
                          );
                        }
                      ) || ''
                    : ''}
                </div>
              </div>
            </TabPanel>
            <TabPanel>
              <div
                className="row p-3"
                style={{ maxHeight: '60vh', overflow: 'hidden scroll' }}
              >
                {businessActivityList
                  ? businessActivityList.map((businessActivity) => {
                      return (
                        <div className="col-6" key={`${businessActivity.id}`}>
                          <div className="form-wrapper p-3 mb-3">
                            <label className="form-label">
                              Line of Business:
                            </label>
                            <h4 className="text-primary">
                              <b>
                                {_.get(businessActivity, 'attributes.name')}
                              </b>
                            </h4>
                            <ViewUpdateBusinessActivityItem
                              data={businessActivity}
                              formData={formData}
                              setFormData={setFormData}
                              businessId={_.get(data, 'id')}
                            />
                          </div>
                        </div>
                      );
                    })
                  : ''}
              </div>
            </TabPanel>
          </Tabs>
        </div>
        <div className="d-flex justify-content-center align-items-center mt-2">
          <button
            disabled={updating || !validateForm.response.is_passed}
            type="button"
            onClick={handleSubmit}
            className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-dark mr-2   "
          >
            <span className="font-weight-bold">Submit</span>
          </button>

          <button
            type="button"
            onClick={() => setModal({ isOpen: false })}
            className="btn btn-dark "
          >
            <span className="font-weight-bold">Close</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

ViewUpdateCalculation.propTypes = {
  // getItem: PropTypes.instanceOf(Function).isRequired,
  data: PropTypes.instanceOf(Object).isRequired,
  updateDelinquentCalculation: PropTypes.instanceOf(Function).isRequired,
  // generateSOA: PropTypes.instanceOf(Function).isRequired,
  getVetRegistrationList: PropTypes.instanceOf(Function).isRequired,
  vetRegistrationList: PropTypes.instanceOf(Object).isRequired,
  updating: PropTypes.bool.isRequired,
  getBusinessNecessaryField: PropTypes.instanceOf(Function).isRequired,
  businessNecessaryField: PropTypes.instanceOf(Array).isRequired,
  handleGenerateSOA: PropTypes.instanceOf(Function).isRequired,
  getCalculationDetailsByBarangay: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => {
  return {
    vetRegistrationList:
      _.get(api, `${c.GET_VET_REGISTRATION_LIST}.list`) || [],
    updating: api.loading.indexOf(c.UPDATE_DELINQUENT_CALCULATION_DETAIL) > -1,
    businessNecessaryField:
      _.get(api, `${c.GET_BUSINESS_NECESSARY_FIELD}.list`) || [],
  };
};

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(ViewUpdateCalculation);
